import { ActionTypes, ReduxAction } from './types';

import { Dispatch } from 'redux';
import { VerpackungService } from '../../api';

export const getVerpackungen =
  (mandantId: number) => async (dispatch: Dispatch<ReduxAction>) => {
    new VerpackungService().getVerpackungen(mandantId).then(result => {
      dispatch({
        type: ActionTypes.GET_VERPACKUNGEN,
        payload: result.data,
      });
    });
  };

export const getVerpackungenOnlyGGVSOrWithout =
  (mandantId: number, isGGVS: boolean | undefined) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    new VerpackungService()
      .getVerpackungenOnlyGGVSOrWithout(mandantId, isGGVS)
      .then(result => {
        dispatch({
          type: ActionTypes.GET_VERPACKUNGEN,
          payload: result.data,
        });
      });
  };
